/**
 * @Author:xyguo
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool'
import { modelUtils } from "@/utils";
import { WizTableForm } from '../../common'
let { WizModal } = component_tool;

let {
  WizContainer, ossFileUtils
} = framework_tool;

class ProgramLogFix extends WizContainer {
  componentName = 'programLogFix';

  constructor(props) {
    super(props);
    this.state = {
      addClassStudentVisible: false,
      personIds:[],
      value: undefined
    };
  }

  _componentDidMount = () => {

  }

  //选择课程弹出框确定按钮事件
  _fixProgramLogSubmit = (e,data) => {
    let obj = this.state.value;
    const {id} = this.props;
    let programIdList = [];
    let programNames = [];
    if (obj && obj instanceof Array && obj.length > 0) {
      if(obj.length > 10){
        wizNotice.warn('最多选择10门课程,请确认后重试');
        return
      }
      obj.forEach(key => {
        programIdList.push(key.id);
          programNames.push(key.name);
      });
      let content='以下课程会生成课程记录:'+programNames
      WizModal.confirm({
        title: "注意",
        content,
        onOk: () => {
          this.doAction({
            path: 'program/fixProgramLog',
            payload: {
              key: 'program@fixProgramLog',
              apiParams: {
                id:id,
                programIdList:programIdList
              }
            }
          });
          this.props.changeModal(false);
        },
        onCancel() {
        },
      });
      
    }else{
      wizNotice.warn('请选择课程后重试');
    }
  };

  _onCancel= (e) =>{
    this.props.changeModal(false);
  };

  setFileData(nextKeys, nextRows) {
    this.setState({
      value: nextKeys
    })
  }

  _render() {
    const {personIds} = this.props;
    let programConfig = WizTableForm.Config.program(this, { apiParams: { } })
    let tableFormProps = {
      title: '选择课程',
      showModal:false,
      visible:false,
      showSelectValue: true,
      showSelect:true,
      selectType: 'checkbox',
      initRows: [],
      value: [],
    };


    return <WizTableForm
      {...programConfig} {...tableFormProps}
     // onSubmit={this._addClassStudentSubmit}
      onSelectedRows={this.setFileData.bind(this)}
    />
  }
}

const mapStateToProps = (state, ownProps) => {
  
  return {
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(ProgramLogFix);
